module.exports = __webpack_public_path__ + "img/walk.631d884b.svg";